module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": []
    }
  }, [_c('div', {
    staticClass: "folders-breadcrumbs"
  }, [_c('a', {
    on: {
      "click": _vm.goToReports
    }
  }, [_vm._v("Reports")]), _vm._v(" "), _vm._l((_vm.path), function(breadcrumb, idx) {
    return [(idx > 0) ? _c('a', {
      staticClass: "folder-path-link",
      on: {
        "click": function($event) {
          return _vm.goToFolder(breadcrumb.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: {
        'fa-folder-o': idx !== _vm.path.length - 1,
        'fa-folder-open-o': idx === _vm.path.length - 1
      }
    }), _vm._v(_vm._s(breadcrumb.name))]) : _vm._e(), (idx !== _vm.path.length - 1) ? _c('i', {
      staticClass: "fa fa-angle-right"
    }) : _vm._e()]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v(_vm._s(_vm.report.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab === 'results'
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTab('results')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#results",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Results")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'summary',
      disabled: (_vm.isGenerating || _vm.isLoading.reports)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActiveTab('summary')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#summary",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Summary")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'charts',
      disabled: (_vm.isGenerating || _vm.isLoading.reports)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setActiveTab('charts')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#charts",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Charts")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab === 'export',
      disabled: (_vm.isGenerating || _vm.isLoading.reports)
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onExportTabClick.apply(null, arguments)
      }
    }
  }, [_c('a', {
    attrs: {
      "aria-expanded": "false"
    }
  }, [_vm._v("Export")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content marginTop"
  }, [_c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab === 'results'
    },
    attrs: {
      "id": "report-results"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.report.description))]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "form-body"
  }, [(!Object.keys(_vm.report).length) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('report-table', {
    attrs: {
      "total-rows": _vm.totalRows,
      "report": _vm.report,
      "loading": _vm.showLoader,
      "generating": _vm.isGenerating
    },
    on: {
      "refresh-report": _vm.onRefreshReport
    }
  })], 1), _vm._v(" "), (_vm.user.access > 3 && !_vm.report.parent_id) ? _c('div', {
    staticClass: "edit-report-btn"
  }, [_c('router-link', {
    class: ['btn', 'green'],
    attrs: {
      "to": {
        name: 'Reports Edit',
        params: {
          reportid: _vm.$route.params.reportid
        }
      },
      "tag": "a"
    }
  }, [_vm._v("Edit")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.activeTab == 'summary') ? _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab == 'summary'
    },
    attrs: {
      "id": "report-summary"
    }
  }, [_c('report-summary', {
    attrs: {
      "report-id": _vm.report.id
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'charts') ? _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.activeTab == 'charts'
    },
    attrs: {
      "id": "report-charts"
    }
  }, [_c('report-charts', {
    attrs: {
      "report-id": _vm.report.id
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.showExportModal) ? _c('export-modal', {
    attrs: {
      "report-id": _vm.report.id,
      "result-total-rows": _vm.totalRows
    },
    on: {
      "display": function($event) {
        _vm.showExportModal = $event
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0749f88e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reports/ReportView.vue
// module id = 1544
// module chunks = 1